import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { UserType, ROUTES } from './types/auth';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import WorkerDashboard from './pages/WorkerDashboard';
import RequesterDashboard from './pages/RequesterDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VersionInfo from './components/VersionInfo';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <VersionInfo position="bottom-right" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<HomePage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path={ROUTES.WORKER_DASHBOARD}
            element={
              <ProtectedRoute allowedUserTypes={[UserType.WORKER]}>
                <WorkerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.REQUESTER_DASHBOARD}
            element={
              <ProtectedRoute allowedUserTypes={[UserType.REQUESTER]}>
                <RequesterDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ADMIN_DASHBOARD}
            element={
              <ProtectedRoute allowedUserTypes={[UserType.ADMIN]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
